export default "__VITE_ASSET__BBvgmDBU__"